<template>
  <CommonModal
    class="confirm-modal"
    title="荣耀时刻"
    :footer="null"
    :width="684"
    :maskClosable="false"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="honour">
      <div class="honourImg">
        <img :src="require('@/assets/images/honour.png')" alt="">
        <span class="honourTxt">{{honourMsg.honourName}}</span>
      </div>
      <div class="honourMsg">
        恭喜您店铺在{{honourMsg.selectionCycle}}期间，在 “{{honourMsg.rankingListName}}” 排行榜中位列第<span class="tip">{{honourMsg.ranking}}</span>名，
        特颁发 <span class="tip">“{{honourMsg.honourName}}”</span> 称号及《荣誉证书》
        注：相应奖励请根据活动说明指引领取
      </div>
    </div>
  </CommonModal>
</template>

<script>
import CommonModal from '@/components/common-modal'
import _ from 'lodash'
export default {
  components:{
    CommonModal
  },
  computed:{
    honourMsg() {
      let honourMsg = _.get(this.$store.state.popHome.honourTimeInfo, "honour", {})
      return honourMsg ? honourMsg : {}
    }
  }
}
</script>

<style lang="scss" scoped>
.honour {
  display: flex;
  flex-direction: column;
  align-items: center;
  .honourImg {
    position: relative;
    .honourTxt {
      position: absolute;
      bottom: 46px;
      width: 240px;
      left: 90px;
      color: #ffffff;
      font-weight: bold;
      font-size: 25px;
    }
  }
  .honourMsg {
    margin-top: 20px;
    font-size: 16px;
    .tip {
      color: red;
    }
  }
}
</style>
